import { Spin } from "antd";
import { Page } from "react-pdf";
import React, { memo, useEffect, useRef, useState } from "react";

function canvasRef(canvas) {
  if (canvas) {
    canvas.setAttribute("data-sl", "canvas-hq");
  }
}

const ELE_LOAD = <div style={{ visibility: "hidden" }} />;

/**
 * @name PageRender react-pdf 渲染
 * @description 有些PDF会渲染出几千个span节点，导致页面卡顿。
 * 🐞 1. 防止 diff render 无意义渲染，导致 “右侧对话内容” 吐词渲染卡顿
 * 🐞 2. 按需渲染 textLayer，用户交互时再渲染，减少 pdf 滚动卡顿
 *
 * ⚠️ PDF可复制节点，仍然是 “react-pdf” 及依赖库生成，虽然目前显著减少了卡顿。
 *    但是要做到完美复制，在 “react-pdf” v5.5版本环境，还是需要处理pdf文件，https://smallpdf.com/cn/compress-pdf ，且不一定转换了就会满足复制文本的需求。
 */
const PageRender = (props) => {
  const ref = useRef();

  const [render, setRender] = useState(false);

  const [loading, setLoading] = useState(false);

  function onRenderTextLayerChange() {
    if (!render) {
      setRender(true);
      setLoading(true);
    }
  }

  useEffect(() => {
    const ele = ref.current.querySelector(
      ".textLayer, .react-pdf__Page__textContent",
    );
    if (!ele && !render) return;
    const observer = new MutationObserver(() => {
      if (ele.childElementCount) {
        observer.disconnect();
        setTimeout(() => setLoading(false));
      }
    });
    observer.observe(ele, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [render]);

  return (
    <div ref={ref}>
      <Spin spinning={loading} tip="Replicable nodes being generated">
        <Page
          ref={ref}
          {...props}
          loading={ELE_LOAD}
          canvasRef={canvasRef}
          renderTextLayer={render}
          onMouseDown={onRenderTextLayerChange}
          onRenderSuccess={props.onRenderSuccess?.current}
        />
      </Spin>
    </div>
  );
};

export default memo(PageRender);
